export default{
    //Access level checks
    accessLevelOne : 1,
    accessLevelTwo : 2,
    accessLevelThree : 3,
    //End of Access level checks
}